import axios from "axios";

// Prefer same-origin so we never trigger CORS: when the app runs in a real
// browser on a non-localhost domain (preview, prod, custom domain like
// app.bkpro.app), talk to the current origin. The REACT_APP_BACKEND_URL env
// is only used for local dev (localhost:3000 → preview backend) or
// non-browser contexts (SSR / tests).
export function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return envUrl;
  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0";
  return isLocal ? envUrl : window.location.origin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

// Auth strategy: JWT in HttpOnly `access_token` cookie set by the backend on
// login. axios auto-sends cookies via `withCredentials: true` (same-origin
// with the backend on Kubernetes). No token in localStorage — closes the XSS
// exfiltration vector.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => Promise.reject(err),
);

/** Build an authenticated URL for <img>/<audio> tags. Same-origin cookie is
 *  auto-attached by the browser, so no query token is required.  */
export function fileUrl(fileId) {
  return `${API}/files/${fileId}`;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Erreur inconnue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(detail);
}

export default api;
